mem.page('game', function (options) {
  var game = new mem.Game({ tiles: mem.generator[options.difficulty]() }),
    timer;

  function refreshDetails() {
    $('#game-details').html(mem.views.detailsTemplate(game));
  }

  function bindGameEvents() {
    $(game).on('mismatch', function () {
      var mismatchedTiles = $('.game-tile input:not([disabled]):checked').get();

      setTimeout(function () {
        $(mismatchedTiles).attr('checked', false);
      }, 1000);
    });

    $(game).on('match', function () {
      $('.game-tile input:checked').attr('disabled', true);
    });

    $(game).on('won', function () {
      mem.showPage('win', mem.gameStats(game));
    });

    $(game).on('lost', function () {
      mem.showPage('lose');
    });
  }

  function bindUIEvents() {
    // Game tile clicks game tile clicks
    $('main').on('click', '.game-tile input', function (e) {
      var wasChecked = $(this).is(':checked');

      game.flipTile($(this).closest('.game-tile').index());

      return wasChecked;
    });
  }

  function runGameTimer() {
    (function updateTimer() {
      refreshDetails();

      if (game) {
        timer = window.setTimeout(updateTimer, 250);
      }
    })();
  }

  function initializeGame() {
    bindGameEvents();
    bindUIEvents();
    runGameTimer();
  }

  function destroyGame () {
    $(game).off();
    game = undefined;

    window.clearTimeout(timer);
  }

  return {
    data: { game: game, difficulty: options.difficulty },

    init: initializeGame,

    destroy: destroyGame
  }
});
